<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Solicitudes de cambio de documentos
            a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-12.has-text-centered
            .table-responsive
              table#tblLogs.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Usuario
                    th Puesto
                    th Tipo de documento
                    th Origen del cambio
                    th Razon del cambio
                    th Estado actual
                    th Cambio propuesto
                    th Estado de la solicitud
                    th Razon del resultado
                    th Fecha
                    th Acciones
                tbody
                  tr(v-for="(data, index) in logs" :key="data.id")
                    td {{ data.id }}
                    td
                      span {{ data.user_name }}
                    td {{ data.user_work_job }}
                    td {{ orígenes[data.origin_of_change]}}
                    td {{ tipos[data.document_type]}}
                    td {{ data.reason_for_change }}
                    td {{ data.current_status }}
                    td {{ data.proposed_change }}
                    td
                      span {{ estados[data.assessment_result] }}
                    td {{ data.reason_for_assessment_result }}
                    td {{ data.created_at }}
                    td
                      .buttons
                        a.button.is-black.is-rounded.is-size-7(@click="downloadVoucher(data.id)" v-if="data.media_count == 0")
                          i.fas.fa-eye
                        a.button.is-dark.is-rounded.is-size-7(@click="downloadVoucher(data.id)" v-if="data.media_count != 0")
                          i.fas.fa-eye
                        a.button.is-dark.is-rounded.is-size-7(@click="addFile(data.id)" v-if="data.media_count == 1")
                          i.fas.fa-cloud
        input#fileInput(type="file" style="display: none" @change="handleFileChange" ref="fileInput")


</template>

<script>
  import { mapState } from "vuex"
  import sasisopaAPI from "@/services/axios_sasisopa.js";
  import Loader from '@/components/shared/Loader.vue'
  import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
  export default {
    name: 'ChangeRequests_user',
    components: { Loader, NavBarCORP },
    props: {
      updateComponente: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        isLoading: false,
        logs: [],
        changeId: null,
        orígenes: [
        "",
        "Sugerencia",
        "Recomendación ICR",
        "Cambio de tecnología",
        "Hallazgo de auditoría",
        "Acción de mejora",
        "Cambio en el proceso"
        ],
        tipos: [
        "",
        "Manual",
        "Instructivo",
        "Plan",
        "Procedimiento",
        "Programa",
        "Formato"
        ],
        estados: [
        "",
        "GENERADO",
        "APROBADO",
        "RECHAZADO"
        ]
      }
    },
    methods: {
      async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getSolicitudesUsuario(this.$route.params.id);
        const userId = response.id_Usuario;
        const filteredData = response.data.filter(item => item.user_proposes == userId);
        console.log('filtered',filteredData);
        console.log('response',response.data);
        console.log('id',userId);
        this.logs =filteredData;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },

      backPage() {
      this.$router.back()
      },
    async downloadVoucher(id) {
        this.isLoading = true;
        const response = await sasisopaAPI.getRequestVoucher(id);
        this.isLoading = false;
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'voucher_solicitud_cambio.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.closeModal();
    },
    addFile(id) {
      this.changeId = id;
      this.$refs.fileInput.click();
  },
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        try {
            const data = {
              id: this.changeId,
              file: file,
            };
            const response = await sasisopaAPI.postChangeVoucher(data);
            this.fetchData();
            return response;
          } catch (error) {
            this.datosFaltantes.push(error|| 'Error al guardar la terminal.');
            throw error;
          }

      }
    },
    async changeStatus(status,id){
        try {
          const data = {
            "id": id,
            "assessment_result":status ,
            "reason_for_assessment_result":"razon estatica",
          };
          const response = await sasisopaAPI.changeStatusSolicitudes(data);
          this.downloadVoucher(id);
          this.fetchData();
        } catch (error) {
          this.datosFaltantes.push(error|| 'Error al guardar la document.');
          throw error;
        }
    }
    },
    computed: {
      ...mapState(["logueado", "userLogin"])
    },
    created () {
      console.log("created");
      this.fetchData()
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sasisopa/ChangeRequests_user.vue